import { useCallback, useMemo } from 'react'
import { Button, ColumnsType, Icon, Table } from 'components/common'
import moment from 'moment'
import {
  BookingStatusOfTheMonthProductVariants,
  BookingStatusOfTheMonthQuery,
} from 'lib/graphql/storeadmin'

interface BookingMonthlyStatusProps {
  data?: BookingStatusOfTheMonthQuery
  listOfDates?: string[]
  handleDailyView: (day: moment.Moment) => void
  onChangeToDaily: (data: boolean) => void
  loading: boolean
}

export const BookingMonthlyStatusTable = ({
  data,
  listOfDates,
  handleDailyView,
  onChangeToDaily,
  loading,
}: BookingMonthlyStatusProps) => {
  const getDaysName = (date: string) => {
    if (date?.includes('土')) {
      const changeDayNameColor = date?.split(' ')
      return (
        <>
          {changeDayNameColor[0]}
          <p style={{ color: 'blue', marginBottom: '0px' }}>
            {changeDayNameColor[1]}
          </p>
        </>
      )
    } else if (date?.includes('日')) {
      const changeDayNameColor = date?.split(' ')
      return (
        <>
          {changeDayNameColor[0]}
          <p style={{ color: 'red', marginBottom: '0px' }}>
            {changeDayNameColor[1]}
          </p>
        </>
      )
    } else {
      const formatDate = date?.split(' ')
      return (
        <>
          {formatDate[0]}
          <p style={{ marginBottom: '0px' }}>{formatDate[1]}</p>
        </>
      )
    }
  }

  const columns = useMemo<ColumnsType>(() => {
    const columns: ColumnsType = [
      {
        title: '施設 / 日付',
        dataIndex: 'facilityAndDate',
        key: 'facilityAndDate',
        fixed: 'left',
        ellipsis: true,
      },
    ]
    listOfDates?.forEach((date, index) => {
      columns.push({
        title: getDaysName(date),
        dataIndex: index + 1,
        key: `${index}${date}`,
        align: 'center',
        render: (bool) =>
          bool ? (
            <Button
              type="link"
              shape="circle"
              size="small"
              onClick={() => {
                onChangeToDaily(true)
                handleDailyView(moment(bool))
              }}
              style={{
                border: '0px',
                padding: '0px',
                backgroundColor: '#1890ff',
                color: '#1890ff',
              }}
              icon={
                <Icon.CloseCircleOutlined
                  style={{
                    color: '#1890ff',
                    fontSize: '18px',
                  }}
                />
              }
            />
          ) : (
            ''
          ),
      })
    })
    return columns
  }, [handleDailyView, listOfDates, onChangeToDaily])

  const checkBookingDates = useCallback((data: string[]) => {
    const formatData = []
    data?.forEach((item) => {
      const dateForBooking = moment(item).format('DD')
      formatData.push({ [Number(dateForBooking)]: item })
    })
    return formatData
  }, [])

  const formatVariation = useCallback(
    (productVariantData: BookingStatusOfTheMonthProductVariants[]) => {
      const formatVariantData = []
      const variantHaveBooking = []

      productVariantData?.forEach((data) => {
        const getData = checkBookingDates(data?.bookingDates)
        let variantData = {
          key: data?.id,
          facilityAndDate: data?.name,
        }

        getData?.forEach((obj) => {
          variantHaveBooking.push({ ...obj })
          return (variantData = { ...variantData, ...obj })
        })

        formatVariantData.push({
          ...variantData,
        })
      })

      return formatVariantData.length > 0
        ? {
            variantData: formatVariantData,
            variantHaveBooking: variantHaveBooking,
          }
        : null
    },
    [checkBookingDates]
  )

  const dataSource = useMemo<ColumnsType>(() => {
    const dataForReturn = []
    data?.bookingStatusOfTheMonth?.products?.forEach((product, index) => {
      if (product?.variants?.length > 1) {
        const getVariantHaveBooking = formatVariation(
          product?.variants
        )?.variantHaveBooking

        let formatVariationBookingData = {
          key: index,
          facilityAndDate: <strong>{product?.name}</strong>,
          children: formatVariation(product?.variants)?.variantData,
        }
        getVariantHaveBooking?.forEach((x) => {
          formatVariationBookingData = {
            ...formatVariationBookingData,
            ...x,
          }
        })

        dataForReturn.push({
          ...formatVariationBookingData,
        })
      } else {
        const getData = checkBookingDates(product?.variants[0]?.bookingDates)
        let formatSingleVariationData = {
          key: index,
          facilityAndDate: <strong>{product?.name}</strong>,
        }
        getData?.forEach((obj) => {
          return (formatSingleVariationData = {
            ...formatSingleVariationData,
            ...obj,
          })
        })

        dataForReturn.push({
          ...formatSingleVariationData,
        })
      }
    })
    return dataForReturn
  }, [
    checkBookingDates,
    data?.bookingStatusOfTheMonth?.products,
    formatVariation,
  ])

  return (
    <>
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        scroll={{ x: true }}
        loading={loading}
      />
    </>
  )
}
